import React, { ReactNode } from 'react';
import { ItemCreationFieldValue } from '~/Components';
import { BookingGroupSelectionInput } from '~/Components/BookingGroupSelector';

interface EventBookingGroupSelectionProps {
  name: string;
  selectedBookingGroupIds: string[];
  children: ReactNode;
  setFieldValue: ItemCreationFieldValue;
}

export const EventBookingGroupSelection = ({
  name,
  selectedBookingGroupIds,
  children,
  setFieldValue,
}: EventBookingGroupSelectionProps) => {
  const updateBookingGroupList = (uuids: string[]) => {
    setFieldValue(name, uuids);
  };

  return (
    <BookingGroupSelectionInput
      selectedBookingGroupIds={selectedBookingGroupIds}
      updateBookingGroupList={updateBookingGroupList}
    >
      {children}
    </BookingGroupSelectionInput>
  );
};
